import { CommonDataSharedService } from 'app/services/commonDataSharedService';
import { FormValidationService } from './../../../../../services/form-validation.service';
import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  Output,
  SimpleChanges,
  ViewChild
} from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import * as inputMasker from 'vanilla-masker';
import { debounceTime, takeUntil } from 'rxjs/operators';
import { Subject, Subscription } from 'rxjs';
import { NotificationService } from 'app/services';
import { phoneNumberValidates } from 'app/services/validator';
import { ActivatedRoute } from '@angular/router';



@Component({
  selector: 'app-student-contact-phone',
  templateUrl: './student-contact-phone.component.html',
  styleUrls: ['./student-contact-phone.component.scss'] 
})
export class StudentContactPhoneComponent implements OnChanges, OnDestroy {
  // pattern for US phone numbers (999) 999-9999
  phonePattern = /^(\([0-9]{3}\) |[0-9]{3}-)[0-9]{3}-[0-9]{4}$/;
  PHONE_VALIDATORS = Validators.compose([Validators.pattern(this.phonePattern), Validators.minLength(14), Validators.maxLength(14)]);

  @Input() userPhoneData: any;
  @Output() phoneUpdates: EventEmitter<any> = new EventEmitter<any>();

  @ViewChild('additionalPhone') additionalPhone: ElementRef;
  @ViewChild('additionalSms') additionalSms: ElementRef;
  additionalPhoneUpdate: Subscription;
  phoneForm: FormGroup;
  backendUpdate = false;
  primaryPhoneNumber;
  primaryPhone;
  duplicateMobile = false;
  private destroyed$ = new Subject();


  constructor(
    private formBuilder: FormBuilder,
    private _formValidationService: FormValidationService,
    private _commonDataSharedService: CommonDataSharedService,
    private notificationService: NotificationService,
    private routes: ActivatedRoute
  ) {
    this.buildForm();
    this.additionalPhoneUpdate = this._commonDataSharedService.saveEmailPhone.subscribe(() => {
      if (this.phoneForm.value.additionalPhone) {
        this.phoneForm.value.additionalPhone.push({
          number: this.additionalPhone.nativeElement.value,
          sms: this.additionalSms.nativeElement.checked
        })
        this.updatePhone(this.phoneForm.value, 'onPageChange');
      }

    })
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.userPhoneData && changes.userPhoneData.currentValue) {
      this.backendUpdate = true;
      this.hydrateForm(changes['userPhoneData'].currentValue);
      this.backendUpdate = false;
    }
  }

  ngOnDestroy() {
    this.destroyed$.next();
    this.additionalPhoneUpdate.unsubscribe();
  }

  buildForm() {
    this.phoneForm = this.formBuilder.group({
      primaryPhoneId: 0,
      addPhoneControl: ['', this.PHONE_VALIDATORS],
      primaryPhone: ['', this.PHONE_VALIDATORS],
      primaryPhoneSms: false,
      additionalPhone: this.formBuilder.array([]),
      additionalPhoneSMS: this.formBuilder.array([]),
    }, { validator: phoneNumberValidates }
    );
    this.phoneForm.valueChanges
      .filter(() => !this.backendUpdate)
      .pipe(debounceTime(10), takeUntil(this.destroyed$))
      .subscribe(newPhone => this.updatePhone(newPhone, 'onload'));

    this._formValidationService.registerForm('phoneForm', this.phoneForm);
  }

  hydrateForm(newData) {
    this.phoneForm.setControl('additionalPhone', new FormArray([]));
    const preferredPhone = (newData && newData.phone) ? newData.phone.filter(item => item.preferred === true)[0] || newData.phone[0] : {};
    const values = {
      primaryPhoneId: preferredPhone.id || 0,
      primaryPhone: preferredPhone && preferredPhone.areaCode ? `(${preferredPhone.areaCode}) ${preferredPhone.exchange}-${preferredPhone.number}` : '',
      primaryPhoneSms: preferredPhone ? preferredPhone.sms : false,
      additionalPhone: (newData && newData.phone) ? newData.phone.filter(item => item !== preferredPhone).map(function (item) {
        return { number: `(${item.areaCode}) ${item.exchange}-${item.number}`, sms: item.sms, id: item.id }
      }) : [],
      additionalPhoneSMS: (newData && newData.phone) ? newData.phone.filter(item => item !== preferredPhone).map(item => item.sms) : [],
    };


    this.phoneForm.patchValue(values);
    // loop through the additional phone numbers and add them to the instance of our additionalPhone form array so they will be shown in the UI by default
    if (values.additionalPhone.length > 0) {
      const control = <FormArray>this.phoneForm.get('additionalPhone');
      values.additionalPhone.map(phone => {
        control.push(this.createPhone(phone.number, phone.sms));
      });
    }
  }

  createPhone(phone, sms): FormGroup {
    return this.formBuilder.group({
      number: [phone || '', this.PHONE_VALIDATORS],
      sms: !!sms,
    });
  }

  onAddPhoneClicked(phone, sms) {
    const control = <FormArray>this.phoneForm.get('additionalPhone');
    if (!this.phoneForm.value.additionalPhone.map(data => data.number).includes(phone) && this.phoneForm.value.primaryPhone !== phone) {
      control.push(this.createPhone(phone, sms.checked));
      this.additionalSms.nativeElement.checked = false;
      this._commonDataSharedService.duplicateContact.next(true);
    } else {
      this.notificationService.show('error', 'Phone number is already added');
    }
    this.phoneForm.get('addPhoneControl').setValue('');
  }

  removePhone(i: number) {
    const control = <FormArray>this.phoneForm.get('additionalPhone');
    control.removeAt(i);
  }

  updatePhone(values, control) {
    if (control !== 'onPageChange') {
      const currentRoute = this.routes.snapshot.url[0].path;
      this._commonDataSharedService.saveModal.next(currentRoute);
      this.duplicateMobile = false;
      if (this.phoneForm) {
       
        this.primaryPhoneNumber = values.primaryPhone;
        if (this.primaryPhoneNumber) {
          this.primaryPhone =
            {
              id: values.primaryPhoneId,
              areaCode: this.primaryPhoneNumber.substring(1, 4),
              exchange: this.primaryPhoneNumber.substring(6, 9),
              number: this.primaryPhoneNumber.substring(10, 14),
              phoneClassId: 1, preferred: true,
              sms: values.primaryPhoneSms
            };
        }

        const additionalPhones = (values.additionalPhone || []).map((item) => ({
          id: item.id,
          areaCode: item.number.substring(1, 4),
          exchange: item.number.substring(6, 9),
          number: item.number.substring(10, 14),
          phoneClassId: 1, preferred: false,
          sms: item.sms
        }));
        
        const commoArray = {
          phone: this.primaryPhone ? [
            this.primaryPhone
          ].concat(additionalPhones) : additionalPhones,
          valid : this.phoneForm.valid ? true : false
        };

        
           this.phoneUpdates.emit(commoArray);
       
        
      }
    }
  }

  // function masks the input value of the phone number fields, different scenario depending on if
  // the user is changing primary phone, adding a new phone, or changing an already added additional phone
  phoneNumberMask(index) {
    if (index === 'primaryPhone') {
      // Converts value to masked phone
      const maskedPhoneValue = this.maskValue(this.phoneForm.get('primaryPhone').value);
      this.phoneForm.patchValue({ primaryPhone: maskedPhoneValue });
    } else if (index === 'addingNewPhone') {
      // doesn't change the data model, only formats the input of the new phone to be added so it is formatted when added
      this.additionalPhone.nativeElement.value = this.maskValue(this.additionalPhone.nativeElement.value);
    } else {
      // updates the array of additional numbers at the index of the updated number
      const control = <FormArray>this.phoneForm.get('additionalPhone');
      const maskedPhoneValue = this.maskValue(control.at(index).value.number);
      control.at(index).patchValue({ number: maskedPhoneValue });
    }
  }

  // function updates the Sms values in the form
  updateSmsCheckboxValue(index) {
    if (index === 'primaryPhone') {
      this.phoneForm.controls.primaryPhoneSms.setValue(!(this.phoneForm.get('primaryPhoneSms').value));
    } else {
      const control = <FormArray>this.phoneForm.get('additionalPhone');
      const phoneSmsValue = !control.at(index).value.sms;
      control.at(index).patchValue({ sms: phoneSmsValue });
    }
  }

  private maskValue(value) {
    return inputMasker.toPattern(value, '(999) 999-9999');
  }

}
